module.exports = __webpack_public_path__ + "sunsuper.png?8d39c7ac3443c3b426e5be8db967d441";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/sunsuper.png
// module id = 58
// module chunks = 0